import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { ThemeContext } from 'styled-components';
import { CategoryBadgeSelected } from '../../components/Badges/StyledBadge';
import { AnmeldBaseDiv, AnmeldBaseHeader, AnmeldBaseHeaderLogin, CenterDiv } from '../../components/Div/StyledDiv';
import LoadingSpinnerWithText from '../../components/Loading/LoadingSpinnerWithText';
import PhysicianSelectionCardWithAppointments from '../../components/PhysicianSelectionCard/PhysicianSelectionCardWithAppointments';
import PhysicianSelectionCardWithDateSwitcher from '../../components/PhysicianSelectionCard/PhysicianSelectionCardWithDateSwitcher';
import { ParagraphFontSize } from '../../components/StyledParagraph/StyledParagraph';
import { StyledMainHeader, StyledSubHeader } from '../../components/StyledText/StyledHeader';
import AppPropsContext from '../../context/appPropsContext';
import LoginContext, { IDepartmentReasons } from '../../context/loginContext';
import TerminierungContext, { ISelectedPhysician } from '../../context/terminierungContext';
import { TRACK_PAGE_APPOINTMENT_CATEGORY_EXTENDEDPHYSICIAN } from '../../globals/trackingGlobals';
import { useAppProperties } from '../../hooks/useAppProperties';
import { useAppointmentSelection } from '../../hooks/useAppointmentSelection';
import { useGoogleAnalytics } from '../../hooks/useGoogleAnalytics';
import { useLanguage } from '../../hooks/useLanguage';
import useScreenResolution from '../../hooks/useScreenResolution';
import { IPhysiciansFor, getPhysiciansFor, unblockAppointment } from '../../services/RestServices';
import { getMondayDateOfThis, getMondayDateOfThisWeek } from '../../utils/dateUtils';
import { INeuerAccountWL } from '../NeuerAccount/NeuerAccountWL';
// import { AppointmentPhysicianAndTimeslotSelectionForSR } from './AppointmentPhysicanAndTimeslotSelectionForSR';

interface IAppointmentCategoryExtendedPhysician {
    department: string;
    reason: IDepartmentReasons;
    handleTimeslotClick(currentActiveStep: number, hdBooking?: string): void;
    currentActiveStep: number;
    newAccountHashParam?: INeuerAccountWL;
    showSummaryBadgeHeader?: boolean;
}

const AppointmentCategoryExtendedPhysician = (props: IAppointmentCategoryExtendedPhysician) => {
    const themeContext = useContext(ThemeContext);
    const { tmstate, tmdispatch } = useContext(TerminierungContext);
    const { state } = useContext(LoginContext);
    const { apstate } = useContext(AppPropsContext);
    const [allPhysicians, setAllPhysicians] = useState<ISelectedPhysician[]>();
    const { getAllMakroIdsFromFilteredReasons } = useAppointmentSelection();
    const [startDate, setStartDate] = useState<Date>(getMondayDateOfThisWeek());
    const [makroId, setMakroId] = useState<string>('');
    const [hdTimeslots, setHdTimeslots] = useState<string>('');
    const [initalPhysicianIds, setInitialPhysicianIds] = useState<string[]>();
    const [showLoadingSpinner, setShowLoadingSpinner] = useState<boolean>(false);
    const { getCountDaysToVisualize } = useAppProperties();
    const { trackById } = useGoogleAnalytics();

    const { t } = useLanguage();

    const screenSize = useScreenResolution();

    const { getSelectedResource } = useAppointmentSelection();

    const getExtension = (app: any, url: string) => {
        for (const e of app.extension) {
            if (e.url == url) {
                return e.valueString;
            }
        }
        return null;
    };

    const getExtensionJSON = (app: any, url: string) => {
        const sjson = getExtension(app, url);
        if (sjson) {
            return JSON.parse(sjson);
        }
        return null;
    };
    const simulateBehFilterFromLocation = (app: any) => {
        let res = '';
        for (const p of app.participant) {
            const ref = p.actor.reference;
            if (ref.startsWith('Location/')) {
                if (res.length > 0) {
                    res += ',';
                }
                res += ref.substring('Location/'.length);
            } else if (ref.startsWith('Practitioner/')) {
                if (res.length > 0) {
                    res += ',';
                }
                res += ref.substring('Practitioner/'.length);
            }
        }
        return res;
    };
    useEffect(() => {
        trackById(TRACK_PAGE_APPOINTMENT_CATEGORY_EXTENDEDPHYSICIAN);

        const getPhysicians = async () => {
            let physiciansForData: IPhysiciansFor;
            if (tmstate.cancelNewAppointmentData?.data) {
                const app = tmstate.cancelNewAppointmentData?.data;
                const _makroId = app.serviceType[0].coding[0].id;
                const behFilter = simulateBehFilterFromLocation(app);
                setMakroId(_makroId);
                physiciansForData = {
                    makroId: _makroId,
                    selectedReason: getExtensionJSON(app, 'http://www.principa.siegele-software.com/selectedReason')
                        ?.reasonId,
                    selectedInsurance: getExtension(app, 'http://www.principa.siegele-software.com/selectedInsurance'),
                    selectedDepartment: getExtension(
                        app,
                        'http://www.principa.siegele-software.com/selectedDepartment',
                    ),
                    selectedAptType: getExtension(app, 'http://www.principa.siegele-software.com/selectedAptType'),
                    countDaysToVisualize: getCountDaysToVisualize(),
                    extendedPhysicians: apstate.extendedPhysicians,
                    // behFilter: getExtension(app, 'http://www.principa.siegele-software.com/behFilter'),
                    behFilter: behFilter,
                };
            } else {
                const _makroId = getAllMakroIdsFromFilteredReasons();
                setMakroId(_makroId);
                const startOfWeekDate = moment(getMondayDateOfThisWeek()).format('DD.MM.yyyy');
                physiciansForData = {
                    makroId: _makroId,
                    selectedReason: tmstate.selectedReason.reasonId,
                    selectedInsurance: tmstate.selectedInsurance,
                    selectedDepartment: tmstate.selectedDepartment.name,
                    selectedAptType: tmstate.selectedAppointmentType,
                    countDaysToVisualize: getCountDaysToVisualize(),
                    extendedPhysicians: apstate.extendedPhysicians,
                    practitionerRoleId: state.practitionerRoleId,
                    startDate: startOfWeekDate,
                };
                if (props.newAccountHashParam?.behFilter) {
                    physiciansForData.behFilter = props.newAccountHashParam?.behFilter;
                }
            }

            setShowLoadingSpinner(true);
            const physiciansData = await getPhysiciansFor(physiciansForData);
            setShowLoadingSpinner(false);
            if (physiciansData?.physicians) {
                setAllPhysicians(physiciansData.physicians);
                setHdTimeslots(physiciansData.hdTimeslots);
                const allPhysicianIds: string[] = physiciansData.physicians
                    .filter((p) => p.id)
                    .map((p) => p.id.toString());
                setInitialPhysicianIds(allPhysicianIds);
            }
        };

        tmdispatch({
            type: 'RESETTIMESLOT',
        });

        /* unblock appointment */
        const resource_1 = getSelectedResource(1);
        if (resource_1) {
            unblockAppointment(resource_1);
        }

        /* get physicians data*/

        getPhysicians();
    }, []);

    const getNewPhyscianData = async (myDate: moment.Moment) => {
        const physiciansForData: IPhysiciansFor = {
            makroId: makroId,
            selectedReason: tmstate.selectedReason.reasonId,
            selectedInsurance: tmstate.selectedInsurance,
            selectedDepartment: tmstate.selectedDepartment.name,
            selectedAptType: tmstate.selectedAppointmentType,
            countDaysToVisualize: getCountDaysToVisualize(),
            extendedPhysicians: apstate.extendedPhysicians,
            startDate: myDate.format('DD.MM.yyyy'),
            currentPhys: initalPhysicianIds?.join(),
            practitionerRoleId: state.practitionerRoleId,
        };
        if (props.newAccountHashParam?.behFilter) {
            physiciansForData.behFilter = props.newAccountHashParam?.behFilter;
        }

        setShowLoadingSpinner(true);
        const physiciansData = await getPhysiciansFor(physiciansForData);
        setShowLoadingSpinner(false);
        if (physiciansData?.physicians) {
            setAllPhysicians(physiciansData.physicians);
        }
    };

    const handlePreviousDate = () => {
        const offset = apstate.countDaysToVisualize ? getCountDaysToVisualize() : 7;

        const dateToCheck = offset === 7 || offset === 3 ? getMondayDateOfThisWeek() : new Date(); // else-branch === now/today

        let myDate = moment(startDate).add(offset * -1, 'days');

        if (moment(myDate).isBefore(dateToCheck, 'day')) {
            // if beginning is reached, start with monday of this week
            myDate = moment(getMondayDateOfThisWeek());
        }
        setStartDate(myDate.toDate());

        getNewPhyscianData(myDate);
    };

    const handleNextDate = async () => {
        const offset = apstate.countDaysToVisualize ? getCountDaysToVisualize() : 7;

        const myDate = moment(startDate).add(offset, 'days');
        setStartDate(myDate.toDate());

        getNewPhyscianData(myDate);
    };

    const handleStartDate = async (date: string) => {
        // firstPossibleDate = '06.08.2025';

        if (!apstate.countDaysToVisualize || getCountDaysToVisualize() === 7) {
            const beginOfWeek = getMondayDateOfThis(date);
            date = moment(beginOfWeek).format('DD.MM.yyyy');
        }

        const myDate = moment(date, 'DD.MM.yyyy', true);
        setStartDate(myDate.toDate());

        getNewPhyscianData(myDate);
    };

    const DateHeader = () => {
        return (
            <div key="TimeStepper">
                <PhysicianSelectionCardWithDateSwitcher
                    startDate={startDate}
                    handlePreviousDate={handlePreviousDate}
                    handleNextDate={handleNextDate}
                    countDaysToVisualize={apstate.countDaysToVisualize ? getCountDaysToVisualize() : 7}
                />
            </div>
        );
    };
    const allPhysicianCards = () => {
        const allCards: JSX.Element[] = [];

        allPhysicians?.forEach((e: ISelectedPhysician) => {
            const descrList: string[] = typeof e.lines === 'string' ? [e.lines] : e.lines ?? [];

            allCards.push(
                <section key={e.id}>
                    <PhysicianSelectionCardWithAppointments
                        name={e.name}
                        showPicture={true}
                        pict={e.pict ? e.pict : ''}
                        description={descrList}
                        startDate={startDate}
                        maxTimeSlots={6}
                        countDaysToVisualize={apstate.countDaysToVisualize ? getCountDaysToVisualize() : 7}
                        appointments={e.appointments}
                        handleTimelotClick={props.handleTimeslotClick}
                        currentActiveStep={props.currentActiveStep}
                        blockMessage={e.blockMessage}
                        hdBooking={e.hdBooking}
                        showLoadingSpinner={showLoadingSpinner}
                        firstPossibleDate={e.firstPossibleDate}
                        handleStartDate={handleStartDate}
                    />
                </section>,
            );
        });

        return allCards;
    };

    const MyAnmeldBaseHeader = (props) => {
        if (state.isLoggedIn) {
            return <AnmeldBaseHeaderLogin>{props.children}</AnmeldBaseHeaderLogin>;
        } else {
            return <AnmeldBaseHeader>{props.children}</AnmeldBaseHeader>;
        }
    };
    const getTimeslotHeader = () => {
        if (hdTimeslots) {
            return <CenterDiv id="hdTimeSlots" dangerouslySetInnerHTML={{ __html: hdTimeslots }} />;
        }
        return null;
    };

    return (
        <>
            {showLoadingSpinner && (
                <div style={{ position: 'fixed', top: '50%', left: '50%' }}>
                    <LoadingSpinnerWithText loadingText="" />
                </div>
            )}
            {/* 
                <AppointmentPhysicianAndTimeslotSelectionForSR /> 
                TODO: reenable ^ and aria-hidden below
            */}
            <AnmeldBaseDiv id="AppCatExtPhysAnmeldBaseDiv" /* aria-hidden */>
                {getTimeslotHeader()}
                <MyAnmeldBaseHeader>
                    {screenSize.height && screenSize.height > 600 && (
                        <Row xs={1} lg={props.showSummaryBadgeHeader ? 3 : 1}>
                            <Col>
                                {/* Change to more accurate "Behandler/Raum und Termin wählen"? 
                                    (-> adapt in ...ForSR as well)
                                    auch: "Termin buchen" -> "Termin auswählen"
                                 */}
                                <StyledMainHeader>{t('ANMELD', 'Behandler und Termin wählen')}</StyledMainHeader>
                            </Col>
                            {props.showSummaryBadgeHeader && (
                                <>
                                    <Col>
                                        <StyledSubHeader>
                                            {t('ANMELD', 'Fachrichtung')}
                                            <CategoryBadgeSelected
                                                backgroundColor={themeContext.mainColor}
                                                color="white"
                                                marginLeft="20px"
                                                fontSize={ParagraphFontSize.Medium}
                                            >
                                                {props.department ?? ''}
                                            </CategoryBadgeSelected>
                                        </StyledSubHeader>
                                    </Col>
                                    <Col>
                                        <StyledSubHeader>
                                            {t('ANMELD', 'Besuchsgrund')}
                                            <CategoryBadgeSelected
                                                backgroundColor={themeContext.mainColor}
                                                color="white"
                                                marginLeft="20px"
                                                fontSize={ParagraphFontSize.Medium}
                                            >
                                                {props.reason?.reasonName ? props.reason.reasonName : ''}
                                            </CategoryBadgeSelected>
                                        </StyledSubHeader>
                                    </Col>
                                </>
                            )}
                        </Row>
                    )}
                    {DateHeader()}
                </MyAnmeldBaseHeader>
                {allPhysicianCards()}
            </AnmeldBaseDiv>
        </>
    );
};

export default AppointmentCategoryExtendedPhysician;
